import React from 'react';

class QRCodeUrlView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayedURL: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.deepLink !== prevProps.deepLink) {
      this.updateURL();
    }
  }

  componentDidMount() {
    this.updateURL();
  }

  updateURL() {
    const { deepLink = '' } = this.props;
    this.setState({ displayedURL: deepLink });
  }

  render() {
    const { displayedURL } = this.state;
    return (
      <div id="qrcode" className="urlDisplayWrap">
        {displayedURL && <img alt="qrcode" src={displayedURL} />}
      </div>
    );
  }
}

export default QRCodeUrlView;
